import { BaseScreen } from "./BaseScreen";

import { BackHeader } from "./components/BackHeader";

import type { HeaderEvents } from "./components/HeaderEvents";

import type { StateStore } from "../app/state/StateStore";
import type { Screen } from "../app/api/ApiClient";

import { ListTitleBlock } from "../blocks/ListTitleBlock";
import { ProductBlock } from "../blocks/ProductBlock";

import type { Block } from "../blocks/Block";


type ListScreenModel =
    Extract<Screen, { type: "list" }>;

export class ListScreen extends BaseScreen {

    private readonly store: StateStore;

    private readonly headerEvents: HeaderEvents;

    private readonly blocks: Block[] = [];

    private root!: HTMLElement;

    constructor(
        _screen: ListScreenModel,
        store: StateStore,
        headerEvents: HeaderEvents,
        private readonly openKrok: (
            krokId: string
        ) => void
    ) {

        super();

        this.store = store;
        this.headerEvents = headerEvents;

    }

    public override mount(): void {

        super.mount();

        this.root =
            this.buildRoot();

    }

    public override update(): void {

        super.update();

        for (const block of this.blocks) {
            block.unmount();
        }

        const newRoot =
            this.buildRoot();

        this.root.replaceWith(
            newRoot
        );

        this.root =
            newRoot;

    }

    public getRoot(): HTMLElement {

        return this.root;

    }

    private buildRoot(): HTMLElement {

        const root =
            document.createElement("div");

        root.className =
            "list-screen";

        const header =
            new BackHeader(
                this.headerEvents
            );

        header.mount();

        root.appendChild(
            header.getRoot()
        );

        root.style.paddingTop =
            "70px";

        this.buildBlocks();

        for (const block of this.blocks) {

            block.mount();

            root.appendChild(
                block.getRoot()
            );

        }

        return root;

    }

    private buildBlocks(): void {

        this.blocks.length = 0;

        this.blocks.push(
            new ListTitleBlock()
        );

        const products =
            this.store.getState()
                .completedProducts ?? [];

        for (const product of products) {

            this.blocks.push(

                new ProductBlock(
                    product,
                    this.store,
                    this.openKrok
                )

            );

        }

    }

}